module.exports = __webpack_public_path__ + "static/media/modal-close.66f64a5f.svg";